import styled from 'styled-components'

import Row from './Row'
import Col from './Col'
import Link from './Link/styled'
import Heading from './Typography/Heading'

const RelatedLinks = styled(Row).attrs({
  as: 'section',
})`
  padding: ${props => props.theme.gutter * 2}px;

  ${Row} {
    padding: 0;
  }

  ${Heading} {
    flex: 1 1 100%;
    color: ${props => props.theme.colors.tertiary};
  }

  ${Link} {
    padding: 4px 0;
    color: ${props => props.theme.colors.black};
  }

  ${Col} {
    flex: 1 1 100%;
  }

  @media (min-width: 992px) {
    ${Col} {
      flex: 0 0 33.33%;
      max-width: 33.33%;
    }
  }
`

export default RelatedLinks
